// extracted by mini-css-extract-plugin
export default {"schoolsTable":"Dif8TS5vDXFjmIQmNtCR"};